import { ChainId } from '@pancakeswap/chains'

export const getAlchemyUrl = (chainId: number, key?: string) => {
  let host: string | null = null

  switch (chainId) {
    case ChainId.ETHEREUM:
      if (key) {
        host = `eth-mainnet.g.alchemy.com/v2/${key}`
      }
      break
    case ChainId.SEPOLIA:
      if (key) {
        host = `eth-sepolia.g.alchemy.com/v2/${key}`
      }
      break
    default:
      host = null
  }

  if (!host) {
    return null
  }

  const url = `https://${host}`
  return url
}
